import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { agentApi } from '../api/client'

export function useAgents() {
  return useQuery({
    queryKey: ['agents'],
    queryFn: agentApi.list,
    refetchInterval: 15000, // Erreichbarkeit aktuell halten (Heartbeat alle 15-30 s)
  })
}

export function useApproveAgent() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: agentApi.approve,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agents'] })
    },
  })
}

export function useRejectAgent() {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: agentApi.reject,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agents'] })
    },
  })
}
